var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "newsDetail", "data-role": "page" } },
    [
      _c(
        "div",
        {
          staticClass: "newsDetail-content",
          attrs: { "data-position": "fixed" }
        },
        [
          _c("div", { staticClass: "detailWrap" }, [
            _c("div", { staticClass: "detail-h" }, [
              _c("span", { staticClass: "cgy-tag" }, [
                _vm._v(_vm._s(_vm.chn_tag(_vm.News.news_type)))
              ]),
              _vm._v(" "),
              _c("h3", { class: { LargSize: _vm.fz_larg } }, [
                _vm._v(_vm._s(_vm.News.title))
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "article_date",
                  class: { LargSize: _vm.fz_larg }
                },
                [_vm._v(_vm._s(_vm.News.news_date))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-c" }, [
              _vm.News.title_img != ""
                ? _c("div", {
                    staticClass: "mainImg",
                    style: "background-image:url(" + _vm.News.title_img + ")"
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.News.title_img == ""
                ? _c("div", { staticClass: "mainImg" })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "txtContent", class: { LargSize: _vm.fz_larg } },
                [_c("p", { domProps: { innerHTML: _vm._s(_vm.News.content) } })]
              )
            ]),
            _vm._v(" "),
            _vm.MoreNewsRule.length != 0
              ? _c("div", { staticClass: "detail-ref" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "ul",
                    _vm._l(_vm.MoreNewsRule, function(rule, rule_ind) {
                      return _c(
                        "li",
                        { key: rule_ind },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "legalRuleDetail",
                                  params: { id: rule.rule_id }
                                }
                              }
                            },
                            [_vm._v(_vm._s(rule.rule_name))]
                          )
                        ],
                        1
                      )
                    })
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "detail-hashtag",
                staticStyle: { display: "none" }
              },
              [
                _c(
                  "ul",
                  _vm._l(_vm.Tags, function(tag, tag_ind) {
                    return _c("li", { key: tag_ind }, [
                      _vm._v("#" + _vm._s(tag.tag_name))
                    ])
                  })
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "detail-source" }, [
              _c("h4", [_vm._v("文章來源")]),
              _vm._v(" "),
              _c("div", { staticClass: "logowrap" }, [
                _c("p", { staticClass: "s-name" }, [
                  _vm._v(_vm._s(_vm.News.legal_name))
                ]),
                _vm._v(" "),
                _vm.News.legal_logo != null
                  ? _c("div", { staticClass: "logoImg" }, [
                      _c("img", {
                        attrs: { src: _vm.News.legal_logo, alt: "" }
                      })
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "descwrap" }, [
                _vm._v(
                  "\n\t\t\t\t\t\t" +
                    _vm._s(_vm.News.about) +
                    "\n                        "
                ),
                _vm.News.multiLink != null && _vm.News.multiLink.length > 0
                  ? _c(
                      "span",
                      {
                        staticClass: "more",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.windowsOpen(_vm.News.multiLink[0].link)
                          }
                        }
                      },
                      [_vm._v(" <<查看更多 ")]
                    )
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm.MoreNews.length > 1
            ? _c("div", { staticClass: "detailWrap articleWrap" }, [
                _c("div", { staticClass: "detail-c" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _vm.Authority
                    ? _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              _vm.ClaenGotoNewsPage(_vm.News.news_type)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "moreBtn-rt" }, [
                            _vm._v("查看更多 >")
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "cgyContent" }, [
                    _c("div", { staticClass: "articleList" }, [
                      _c(
                        "ul",
                        _vm._l(_vm.MoreNews, function(MoreNews, MoreNews_ind) {
                          return _vm.$route.params.id != MoreNews.news_id
                            ? _c("li", { key: MoreNews_ind }, [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function($event) {
                                        _vm.nextPage(MoreNews.news_id)
                                      }
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "topicImg" }, [
                                      MoreNews.title_img != ""
                                        ? _c("div", {
                                            directives: [
                                              {
                                                name: "lazy",
                                                rawName:
                                                  "v-lazy:background-image",
                                                value: MoreNews.title_img,
                                                expression:
                                                  "MoreNews.title_img",
                                                arg: "background-image"
                                              }
                                            ],
                                            staticClass: "mainImg"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      MoreNews.title_img == ""
                                        ? _c("div", { staticClass: "mainImg" })
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "txt-info" }, [
                                      _c(
                                        "span",
                                        { staticClass: "article_desc" },
                                        [_vm._v(_vm._s(MoreNews.title))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "article_date" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              MoreNews.news_date.split(" ")[0]
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "metaDiv" }, [
                                        _c("span", { staticClass: "cgy-tag" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.chn_tag(MoreNews.news_type)
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm.Authority
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "bookmark-tag",
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    _vm.SetFavorites(
                                                      MoreNews.news_id,
                                                      MoreNews.is_keep
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  class: [
                                                    MoreNews.is_keep
                                                      ? "icon-bookmark-full bookmarkIcon active"
                                                      : "icon-bookmark bookmarkIcon"
                                                  ]
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    ])
                                  ]
                                )
                              ])
                            : _vm._e()
                        })
                      ),
                      _vm._v(" "),
                      _vm.MoreNews_row <= this.MoreNews.length &&
                      this.MoreNews.length >= 10
                        ? _c("div", { staticClass: "moreBtn" }, [
                            _c("p", { staticClass: "loading-rotate" }),
                            _vm._v(" "),
                            _c("p", { staticClass: "loading-tip" }, [
                              _vm._v("載入更多")
                            ])
                          ])
                        : _vm._e()
                    ])
                  ])
                ])
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.Authority
        ? _c("div", { staticClass: "qk-functionBar active" }, [
            _c(
              "div",
              {
                class: [
                  _vm.Authority
                    ? "qk-functionBar-wrap-col4"
                    : "qk-functionBar-wrap-col1"
                ]
              },
              [
                _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        _vm.SetRecommend(_vm.News.news_id, _vm.News.is_push)
                      }
                    }
                  },
                  [
                    _c("span", [
                      _c("i", {
                        class: [
                          _vm.News.is_push
                            ? "icon-smile-full active"
                            : "icon-smile"
                        ]
                      }),
                      _vm._v("推")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        _vm.SetFavorites(_vm.News.news_id, _vm.News.is_keep)
                      }
                    }
                  },
                  [
                    _c("span", [
                      _c("i", {
                        class: [
                          _vm.News.is_keep
                            ? "icon-bookmark-full bookmarkIcon active"
                            : "icon-bookmark bookmarkIcon"
                        ]
                      }),
                      _vm._v("收藏")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { on: { click: _vm.ChanegSize } }, [_vm._m(3)]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    on: {
                      click: function($event) {
                        _vm.Share(_vm.News.news_id, _vm.News.title)
                      }
                    }
                  },
                  [_vm._m(4)]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("favoritesToast", {
        attrs: {
          show: _vm.toastControl.show,
          full: _vm.toastControl.full,
          content: _vm.toastControl.content,
          showTime: _vm.toastControl.showTime
        },
        on: {
          close: function($event) {
            _vm.toastControl.show = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", [
      _c("i", { staticClass: "icon-article-pen" }),
      _vm._v("公寓大廈管理條例相關法條")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detailWrap articleWrap questionnaire" }, [
      _c("div", { staticClass: "detail-c" }, [
        _c("div", { staticClass: "questionnaire" }, [
          _c(
            "a",
            {
              attrs: {
                href:
                  "https://docs.google.com/forms/d/e/1FAIpQLSetKmRasOJyXyx4XNOt8g_bFeUpytB5dTVdzRnPkAhAN_Ezzg/viewform"
              }
            },
            [
              _c("div", { staticClass: "img" }),
              _vm._v(" "),
              _c("div", { staticClass: "txt" }, [
                _c("span", { staticClass: "title" }, [
                  _vm._v("想看什麼快來許願吧！")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "content" }, [
                  _vm._v("不管你想看甚麼,我們都幫你準備。")
                ])
              ])
            ]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "cgyTitle" }, [
      _c("i", { staticClass: "titleIcon icon-article-pen" }),
      _vm._v("相關文章")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("i", { staticClass: "icon-letterA" }),
      _vm._v("大小")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "icon-share" }), _vm._v("分享")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33f54a18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33f54a18","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/newsDetail.vue
// module id = null
// module chunks = 